export default __webpack_public_path__ + "static/slider_1-2e574ff424d30ed8e93a75d9cd63a1c0.jpg";